import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=b8260d9e&scoped=true&"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrivacyPolicyModal.vue?vue&type=style&index=1&id=b8260d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8260d9e",
  null
  
)

export default component.exports